import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { TaxResidenceType } from '../../enums/TaxResidenceType.js';
export class NationalityResponse extends BaseMessage {
    nationality;
    countryCode;
    isPrimary;
    createdBy;
    updatedBy;
}
__decorate([
    Field.string({
        description: 'Nationality name',
        required: true,
    }),
    __metadata("design:type", String)
], NationalityResponse.prototype, "nationality", void 0);
__decorate([
    Field.string({
        description: 'Country Code',
    }),
    __metadata("design:type", String)
], NationalityResponse.prototype, "countryCode", void 0);
__decorate([
    Field.boolean({
        description: 'Primary country',
        required: true,
    }),
    __metadata("design:type", Boolean)
], NationalityResponse.prototype, "isPrimary", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], NationalityResponse.prototype, "createdBy", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], NationalityResponse.prototype, "updatedBy", void 0);
export class TaxResidentCountriesResponse extends BaseMessage {
    country;
    countryCode;
    tin;
    reasonForNoTin;
    createdBy;
    updatedBy;
}
__decorate([
    Field.string({ required: true, description: 'country name' }),
    __metadata("design:type", String)
], TaxResidentCountriesResponse.prototype, "country", void 0);
__decorate([
    Field.string({
        description: 'country code',
    }),
    __metadata("design:type", String)
], TaxResidentCountriesResponse.prototype, "countryCode", void 0);
__decorate([
    Field.string({
        description: 'TIN number',
    }),
    __metadata("design:type", String)
], TaxResidentCountriesResponse.prototype, "tin", void 0);
__decorate([
    Field.string({
        description: 'Reason for no TIN number',
    }),
    __metadata("design:type", String)
], TaxResidentCountriesResponse.prototype, "reasonForNoTin", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], TaxResidentCountriesResponse.prototype, "createdBy", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], TaxResidentCountriesResponse.prototype, "updatedBy", void 0);
export class NationalityAndTaxResidentResponse extends BaseMessage {
    id;
    nationalities;
    taxResidence;
    taxResidentCountries;
    confirmTaxResidency;
    isDualNationality;
}
__decorate([
    Field.string({
        description: 'Id of an individual',
        required: true,
        format: 'uuid',
    }),
    __metadata("design:type", String)
], NationalityAndTaxResidentResponse.prototype, "id", void 0);
__decorate([
    Field.array({
        items: {
            type: 'message',
            message: NationalityResponse,
        },
        required: false,
    }),
    __metadata("design:type", Array)
], NationalityAndTaxResidentResponse.prototype, "nationalities", void 0);
__decorate([
    Field.enum({
        enum: TaxResidenceType,
        description: 'Tax Residencies',
    }),
    __metadata("design:type", String)
], NationalityAndTaxResidentResponse.prototype, "taxResidence", void 0);
__decorate([
    Field.array({
        items: {
            type: 'message',
            message: TaxResidentCountriesResponse,
        },
        required: false,
    }),
    __metadata("design:type", Array)
], NationalityAndTaxResidentResponse.prototype, "taxResidentCountries", void 0);
__decorate([
    Field.boolean({
        description: 'Confirm Tax Residency',
    }),
    __metadata("design:type", Boolean)
], NationalityAndTaxResidentResponse.prototype, "confirmTaxResidency", void 0);
__decorate([
    Field.boolean({
        description: 'dual nationality flag',
        required: false,
    }),
    __metadata("design:type", Boolean)
], NationalityAndTaxResidentResponse.prototype, "isDualNationality", void 0);
//# sourceMappingURL=NationalityAndTaxResidentResponse.js.map